import validator from 'validator';

export function parseType(value) {
  if (typeof value === 'number' || typeof value === 'boolean') {
    return null;
  }
  if (!value || value.trim().length === 0) {
    return null;
  }
  if (validator.isIP(value, 4)) {
    return 'ipv4';
  }
  if (validator.isIP(value, 6)) {
    return 'ipv6';
  }
  if (validator.isFQDN(value)) {
    return 'domain';
  }
  if (validator.isURL(value)) {
    return 'url';
  }
  if (validator.isHash(value, 'sha256')) {
    return 'hash_sha256';
  }
  if (validator.isHash(value, 'md5')) {
    return 'hash_md5';
  }
  return null;
}
